import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Briefcase, Users, Clock } from 'lucide-react';

const TransfertEvenementEntreprise = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Transfert Événement Entreprise | Chauffeur Privé Corporate Bruxelles</title>
        <meta name="description" content="Service de transfert VIP pour événements d'entreprise à Bruxelles. Flotte premium pour séminaires, conférences, galas. Devis sur mesure." />
        <meta name="keywords" content="transfert entreprise bruxelles, chauffeur corporate, transport événement entreprise, vtc business" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/transfert-evenement-entreprise" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Briefcase className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Transfert Événement d'Entreprise
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Service de transport corporate premium pour vos événements professionnels. Flotte VIP, ponctualité garantie.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transport VIP pour Événements Corporate</h2>
          <p className="text-gray-300 mb-4">
            <strong>Service de transfert pour événements d'entreprise</strong> à Bruxelles. Flotte premium Mercedes & Lexus 
            pour séminaires, conférences, galas, team building. Gestion de groupes, coordination logistique, service irréprochable.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Événements Pris en Charge</h3>
          <ul className="text-gray-300 space-y-2">
            <li>💼 Séminaires & Conférences</li>
            <li>🎉 Galas & Soirées d'Entreprise</li>
            <li>🤝 Team Building & Incentives</li>
            <li>🏛️ Salons & Foires Professionnels</li>
            <li>✈️ Transferts Aéroport Groupes VIP</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TransfertEvenementEntreprise;